import React from "react";
import { Link, useLocation } from "react-router-dom";

import { buildTeamScopedPath } from "../../utils/teamRouteTarget";

export const TEAM_CENTER_NAV_ITEMS = [
  { label: "Dashboard", path: "/team-center/dashboard" },
  { label: "Team Settings", path: "/team-center/settings" },
  { label: "Team Subscription", path: "/team-setup-billing", administration: true },
  { label: "Team Payment Setup", path: "/team-setup-payers", administration: true },
];

const canonicalPath = (path) => ({'/team-center/subscription':'/team-setup-billing','/team-center/payment-setup':'/team-setup-payers'}[path] || path);

function NavigationGroups({renderLink}) {
  return <>
    <div className="TmO-dashboard__navigation-pages">{TEAM_CENTER_NAV_ITEMS.filter(item => !item.administration).map(renderLink)}</div>
    <div className="TmO-dashboard__navigation-administration">{TEAM_CENTER_NAV_ITEMS.filter(item => item.administration).map(renderLink)}</div>
  </>;
}

export function TeamCenterNavigationView({ teamId = null, pathname = "/team-center/dashboard", onNavigate }) {
  return <nav className="TmO-dashboard__navigation" aria-label="Team Center sections">
    <NavigationGroups renderLink={(item) => <a key={item.path}
      href={buildTeamScopedPath(item.path, teamId)}
      className={canonicalPath(pathname) === item.path ? "is-active" : ""}
      aria-current={canonicalPath(pathname) === item.path ? "page" : undefined}
      onClick={(event) => { if (onNavigate) { event.preventDefault(); onNavigate(item.path); } }}>
      {item.label}
    </a>} />
  </nav>;
}

export default function TeamCenterNavigation({ teamId = null }) {
  const location = useLocation();

  return (
    <nav className="TmO-dashboard__navigation" aria-label="Team Center sections">
      <NavigationGroups renderLink={(item) => {
        const isActive = canonicalPath(location.pathname) === item.path;

        return (
          <Link
            key={item.path}
            to={buildTeamScopedPath(item.path, teamId)}
            className={isActive ? "is-active" : ""}
            aria-current={isActive ? "page" : undefined}
          >
            {item.label}
          </Link>
        );
      }} />
    </nav>
  );
}
